var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgNitroN(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.766 3.24l-3.467 7.573-.373-7.573h-5.743l-3.618 7.918a39.454 39.454 0 004.809 2.013h.012l.338-.745.012.867c2.637.879 5.404 1.513 8.275 1.958h.012l5.497-12h-5.754V3.24zm-8.73 10.565c-1.716-.679-3.304-1.435-4.658-2.236L3.48 20.078h5.742l2.86-6.25c-.023-.011-.035-.022-.047-.022zm8.508 2.435a46.885 46.885 0 01-7.808-2.168l.046 5.994h6.011l1.751-3.826z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgNitroN);
export default ForwardRef;
